export const enum FeatureToggle {
  COURSE_MAP_ADDITIONAL_INFORMATION = "COURSE_MAP_ADDITIONAL_INFORMATION",
}

export const toggledFeatures: string[] = [FeatureToggle.COURSE_MAP_ADDITIONAL_INFORMATION];
// export const toggledFeatures: string[] = [];
